import { Link, useLocation } from "react-router-dom";

import useGoBack from "@/hooks/useGoBack";
import useTranslations from "@/i18n/useTranslations";
import BackArrowIcon from "@/shared-components/icons/components/public/BackArrowIcon";
import SuarteName from "@/shared-components/icons/components/public/SuarteName";
import Heading from "@/shared-components/text/components/Heading";
import Text from "@/shared-components/text/components/Text";

import "./index.css";

export default function OriginalsReturnRefundPolicyPage() {
  const t = useTranslations("common.return_and_refund_policy");
  const location = useLocation();
  const fallbackRoute =
    typeof location.state?.fromPath === "string" &&
    location.state.fromPath.startsWith("/")
      ? location.state.fromPath
      : "/";
  const goBackHandler = useGoBack(fallbackRoute);

  return (
    <div className="originals-return-refund-policy__page">
      <div className="originals-return-refund-policy__header">
        <BackArrowIcon
          className="originals-return-refund-policy__back-button"
          onClick={goBackHandler}
        />
        <SuarteName className="originals-return-refund-policy__suartename" />
      </div>

      <header className="originals-return-refund-policy__hero">
        <h1>
          <Heading className="originals-return-refund-policy__title">
            {t("title")}
          </Heading>
        </h1>

        <Text
          className="originals-return-refund-policy__text"
          paragraph
          justify
        >
          {t("intro.primary")}
        </Text>

        <Text
          className="originals-return-refund-policy__text"
          paragraph
          justify
        >
          {t("intro.secondary_before_link")}{" "}
          <Link
            className="originals-return-refund-policy__link"
            to="/limited-editions-return-and-refund-policy"
            state={{ fromPath: "/return-and-refund-policy" }}
          >
            {t("intro.limited_editions_link")}
          </Link>
          .
        </Text>
      </header>

      <section className="originals-return-refund-policy__section">
        <Text className="originals-return-refund-policy__subheading">
          {t("resolution.title")}
        </Text>
        <Text
          className="originals-return-refund-policy__text margin"
          paragraph
          justify
        >
          {t("resolution.body")}
        </Text>
      </section>

      <section className="originals-return-refund-policy__section">
        <Text className="originals-return-refund-policy__subheading">
          {t("gallery_issues.title")}
        </Text>
        <Text
          className="originals-return-refund-policy__text"
          paragraph
          justify
        >
          {t("gallery_issues.intro")}
        </Text>
        <ul className="originals-return-refund-policy__list">
          <li>{t("gallery_issues.items.lost")}</li>
          <li>{t("gallery_issues.items.damaged")}</li>
          <li>{t("gallery_issues.items.not_as_described")}</li>
          <li>{t("gallery_issues.items.quality")}</li>
          <li>{t("gallery_issues.items.counterfeit")}</li>
        </ul>
        <Text
          className="originals-return-refund-policy__text margin"
          paragraph
          justify
        >
          {t("gallery_issues.outro")}
        </Text>
      </section>

      <section className="originals-return-refund-policy__section">
        <Text className="originals-return-refund-policy__subheading">
          {t("ineligible.title")}
        </Text>
        <Text
          className="originals-return-refund-policy__text"
          paragraph
          justify
        >
          {t("ineligible.intro")}
        </Text>
        <ul className="originals-return-refund-policy__list">
          <li>{t("ineligible.items.vat")}</li>
          <li>{t("ineligible.items.dimensions")}</li>
          <li>{t("ineligible.items.colour")}</li>
          <li>{t("ineligible.items.details")}</li>
          <li>{t("ineligible.items.customs")}</li>
          <li>{t("ineligible.items.delay")}</li>
          <li>{t("ineligible.items.off_platform")}</li>
        </ul>
      </section>
    </div>
  );
}
